import { HttpService } from '@Engage.Data.Services';
import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
import { CookiesStorageService } from '@Engage.Data.Services';
import { StorageKeys } from '@Engage.Data.Constants';
import { addDays, Locations } from '@Engage.Core';
/**
 * Mirrors ConneXt v2 ActionRepository messaging methods exactly.
 *
 * Cache strategy (matches v2):
 *   - Messages stored in localStorage under nxt_msg_dt (no key expansion)
 *   - Cache is valid while the cookie nxt_msg_expr exists
 *   - CookiesStorageService.get with no options → expandKey defaults to true,
 *     useRootDomain defaults to app setting — same as v2 ActionRepository.getMessagingData()
 */
export class MessagingRepository {
    /**
     * Returns cached messages if the expiry cookie is still alive, otherwise null.
     * Mirrors v2: !CookiesStorageService.get(StorageKeys.ConnextMessagingDataExpire)
     */
    static getCachedMessages() {
        const expired = !CookiesStorageService.get(StorageKeys.ConnextMessagingDataExpire);
        if (expired)
            return null;
        return localStorageService.get(StorageKeys.ConnextMessagingData) || {};
    }
    /** Mirrors v2: LocalStorageService.set(StorageKeys.ConnextMessagingData, messages) */
    static setCachedMessages(messages) {
        localStorageService.set(StorageKeys.ConnextMessagingData, messages);
    }
    /**
     * Sets the expiry cookie — default 1 day.
     * Mirrors v2: ActionRepository.setCookiesMessagingDataExpire(dateExpire, options)
     */
    static setExpiryCookie(days = 1) {
        CookiesStorageService.set(StorageKeys.ConnextMessagingDataExpire, new Date().toISOString(), { expires: addDays(days) });
    }
    /**
     * Fetches user messages from the API.
     * Mirrors v2: ActionRepository.getUserMessages(params, { location: Locations.Messaging })
     */
    static fetchUserMessages(params) {
        return HttpService.get('user/messages', params, { location: Locations.Messaging });
    }
}
